import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  function messageShow() {
    alert("coming soon");
  }
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am passionate about programming and continually strive to expand
              my knowledge and skills.
              <br />
              <br />I am proficient in core programming languages such as
              <i>
                <b className="purple"> PHP, Javascript and Python. </b>
              </i>
              <br />
              <br />
              My interests lie in developing innovative &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> as well
                as <b className="purple">Mobile Applications.</b>
              </i>
              <br />
              <br />
              Whenever possible, I channel my passion into developing products
              using <b className="purple">PHP, Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  // href="https://github.com/soumyajit4419"
                  // target="_blank"
                  // rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  onClick={() => {
                    messageShow();
                  }}
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  // href="https://twitter.com/Soumyajit4419"
                  // target="_blank"
                  // rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  onClick={() => {
                    messageShow();
                  }}
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  // href="https://www.linkedin.com/in/soumyajit4419/"
                  //target="_blank"
                  // rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  onClick={() => {
                    messageShow();
                  }}
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  // href="https://www.instagram.com/soumyajit4419"
                  // target="_blank"
                  // rel="noreferrer"
                   className="icon-colour home-social-icons"

                  onClick={() => {
                    messageShow();
                  }}
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
